// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"9d30db8b","678":"d7ed4fa6","787":"0f56bde6"}[chunkId] + ".chunk.js";
};